/**
 *
 * Wait for a condition to become true, then resolve promise
 *
 * usage: until(() => this.someBoolean)
 *
 * @param {function} condition - function that returns a value to be evaluated
 * @param {*} success - returned on success
 * @returns {Promise}
 *
 */
const until = (condition, success) => {
  const poll = resolve => {
    if (condition()) {
      resolve(success ? success : null);
    } else {
      // check condition again in 100ms
      setTimeout(() => poll(resolve), 100);
    }
  };

  return new Promise(poll);
};

export default until;
